import styled from 'styled-components';
import { ListItemLink, Popup } from '../../styled/Popup.styled';
export const CustomerPopup = styled(Popup) `
  width: 220px;
  margin-top: -8px;
`;
export const StyledLink = styled(ListItemLink) `
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  color: ${({ theme }) => theme.colorsV2.font.textPrimary};
  font-weight: 400;
`;
//# sourceMappingURL=CustomerPopup.styled.js.map